export enum ITEM_STATUS {
	REQUESTED = "requested",
	IN_STOCK = "in-stock",
	BOOKED = "booked",
	SOLD = "sold",
	CANCELED = "canceled"
}
